import React,{useState,useEffect,useCallback,useRef} from 'react'
import '../styles/search.css'
import MainBody from '../comps/mainBody'
import {useSelector,useDispatch} from 'react-redux'
import * as actions from '../data/search_data'
import * as normalActions from '../store/actions'
import {useNavigate} from 'react-router-dom';
import {Helmet} from "react-helmet";
import * as authAction from '../store/authAction'
import * as actionss from '../data/follow_data'
import { BiSearch} from 'react-icons/bi';
import { isPhotoPost, isShortPost, isMusicPost } from '../utils/mediaRoute'
import WebResults from '../comps/webResults'

const isLongPost = (item) => !isShortPost(item) && !isPhotoPost(item) && !isMusicPost(item)

const Search = () =>{
  const navigate = useNavigate();
  const [search,setSearch] = useState('')
  const [searchAnie,setSearchAnie] = useState(false);
  const [isload,setLoad] = useState(false)
  const [type,setType] =useState('searchLong')
  const [page,setpage] = useState(5)
  const [webItems,setWebItems] = useState([])
  const [webFirst,setWebFirst] = useState(1)
  const dispatch = useDispatch();
  const pageRef = useRef(5);
  const webFirstRef = useRef(1);
  const searchRef = useRef('');
  const typeRef = useRef(type);
  const loadingMore = useRef(false);
  searchRef.current = search;
  typeRef.current = type;
  webFirstRef.current = webFirst;

  useEffect(()=>{
    const boot = async () => {
      const userData = localStorage.getItem('userdata');
      if (userData) {
        try {
          const {id,pid} = JSON.parse(userData);
          await dispatch(authAction.auth(id,pid));
          await dispatch(actionss.get_follow());
        } catch (err) {}
      }
    }
    boot()
  },[dispatch])


  const fetchWeb = async (word, first = 1, append = false) => {
    const q = String(word || '').trim()
    if (!q) {
      if (!append) setWebItems([])
      return 0
    }
    try {
      const res = await fetch(`/api/search/web?q=${encodeURIComponent(q)}&first=${first}`)
      const data = await res.json()
      const items = data.items || []
      if (append && !items.length) return 0
      setWebItems(current => append ? current.concat(items) : items)
      const next = first + (items.length || 10)
      webFirstRef.current = next
      setWebFirst(next)
      return items.length
    } catch (err) {
      if (!append) setWebItems([])
      return 0
    }
  }

  const getData2 = useCallback(async () => {
    if (loadingMore.current) return
    const q = String(searchRef.current || '').trim()
    if (!q) return { longs: 0, shorts: 0 }
    loadingMore.current = true
    try {
      if (typeRef.current === 'searchWeb') {
        const added = await fetchWeb(q, webFirstRef.current, true)
        return { longs: added || 0, shorts: 0 }
      }
      const added = await dispatch(actions.set_searchh(q, pageRef.current, 3))
      pageRef.current += 3
      setpage(pageRef.current)
      return added || { longs: 0, shorts: 0 }
    } catch (err) {
      return { longs: 0, shorts: 0 }
    } finally {
      loadingMore.current = false
    }
  }, [dispatch])


  const listt = useSelector(state => state.searchReduse);
  const list2 = useSelector(state => state.followReduse.follow);
  const playSound = () => {
    try {
      new Audio('./click.mp3').play().catch(() => {})
    } catch (err) {}
  }
  const posts = listt.videos || []
  const photos = (listt.images && listt.images.length ? listt.images : posts.filter(isPhotoPost))
  let list;
  let bodyType = 'l'
  if (type === 'searchUsers') {
    list = listt.searchUsers
    bodyType = 'search'
  } else if (type === 'searchCommunities') {
    list = listt.communities
    bodyType = 'community'
  } else if (type === 'searchShort') {
    list = posts.filter(isShortPost)
    bodyType = 's'
  } else if (type === 'searchPhoto') {
    list = photos
    bodyType = 'i'
  } else if (type === 'searchMusic') {
    list = posts.filter(isMusicPost)
    bodyType = 'a'
  } else {
    list = posts.filter(isLongPost)
    bodyType = 'l'
  }

  const searchHandle = async (event)=>{
    if (event) event.preventDefault();
    if(search.length === 0){
      return;
    }
    setLoad(true)
    pageRef.current = 5
    webFirstRef.current = 1
    loadingMore.current = false
    try {
      await Promise.all([
        dispatch(actions.set_search(search,0,5)),
        fetchWeb(search, 1, false)
      ])
    } catch (err) {}
    setpage(5);
    setWebFirst(1);
    setLoad(false)
    setSearchAnie(true);
  }
  const translations = useSelector(state => state.lang_reduse.lang);
  return(
    <section className="Search">
      <Helmet>
        <meta name="theme-color" content="#000000" />
      <title>pinweelo Search ,discover new things ,people and videos</title>
    <meta name="description" content='here you can search for users and videos'/>
  <meta name='keywords' content='search,discover,search page,meet'/>
   <link rel="canonical" href="https://pinweelo.com/search" />
      </Helmet>
<form className="searchBar" onSubmit={searchHandle}>
  <input
    placeholder={translations.searchHere}
    value={search}
    onChange={e=>setSearch(e.target.value)}
    aria-label={translations.searchHere || 'Search'}
  />
  <button type="submit" className="searchBarButton" aria-label={translations.search || 'Search'}>
    <BiSearch />
  </button>
</form>
<div className={searchAnie ? 'searchOptions isVisible' : 'searchOptions'}>
  <span onClick={()=> {setType("searchLong");playSound()}} className={type === 'searchLong'? 'button activeSearch':'button'}>long</span>
  <span onClick={()=> {setType("searchShort");playSound()}} className={type === 'searchShort'? 'button activeSearch':'button'}>short</span>
  <span onClick={()=> {setType("searchPhoto");playSound()}} className={type === 'searchPhoto'? 'button activeSearch':'button'}>photo</span>
  <span onClick={()=> {setType("searchMusic");playSound()}} className={type === 'searchMusic'? 'button activeSearch':'button'}>music</span>
  <span onClick={()=> {setType("searchUsers");playSound()}}  className={type === 'searchUsers'? 'button activeSearch':'button'}>users</span>
  <span onClick={()=> {setType("searchCommunities");playSound()}} className={type === 'searchCommunities'? 'button activeSearch':'button'}>community</span>
  <span onClick={()=> {setType("searchWeb");playSound()}} className={type === 'searchWeb'? 'button activeSearch':'button'}>web</span>
</div>
<div className={searchAnie ? 'searchResults isVisible' : 'searchResults'}>
  <div key={type} className="searchResultsPane">
  {type === 'searchWeb' ? (
    <WebResults
      items={webItems}
      isload={isload}
      emptyTitle={translations.thereisnoweb || translations.thereisnoresults}
      onMore={searchAnie ? getData2 : undefined}
    />
  ) : (
  <MainBody page={page} fetchData={searchAnie ? getData2 : undefined} list2={list2} isload={isload} go={navigate} Visted={true} list={list || []} type={bodyType} dispatch={dispatch} normalActions={normalActions} emptyTitle={type === 'searchUsers' ? translations.thereisnopeople : type === 'searchCommunities' ? 'No communities yet' : type === 'searchPhoto' ? translations.thereisnoimages : type === 'searchMusic' ? 'No music yet' : translations.thereisnoresults} />
  )}
  </div>
</div>
    </section>
  )
}
export default Search;
